import strings from './FieldStrings.resx';
import { IItemCache } from '../../models/IItemCacheObserver';
import { getConfiguration } from '../../models/configuration/getConfiguration';
import { enableDetailsListFieldRenderPageLoadBarrierFacet } from '../../facets/ConfigurationFacets';
import { getPageLoadBarrier } from '../../operations/pageLoad';

/**
 * @internal
 */
export function getBooleanDisplayValue(value: boolean): string {
    return value ? strings.Yes : strings.No;
}

/**
 * @internal
 */
export function getFieldRenderBarrier(itemCache: IItemCache): Promise<void> | undefined {
    const {
        enableDetailsListFieldRenderPageLoadBarrier
    } = getConfiguration(itemCache, {
        enableDetailsListFieldRenderPageLoadBarrier: enableDetailsListFieldRenderPageLoadBarrierFacet
    });

    return enableDetailsListFieldRenderPageLoadBarrier ? getPageLoadBarrier(itemCache) : undefined;
}
